import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const CoffeeCupStrike = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M12.5 9.375C12.5 8.33333 13.2441 7.29167 14.7322 7.29167C16.3758 7.29167 17.7083 5.95918 17.7083 4.31548V3.64583M9.00008 7.5C9.00008 6.5 9.73245 5.72917 11.4583 5.72917C12.609 5.72917 13.5417 4.79643 13.5417 3.64583V3.125M16.6667 11.4583H19.2708C20.7091 11.4583 21.875 12.6243 21.875 14.0625C21.875 15.5007 20.7091 16.6667 19.2708 16.6667H17.7083V12.0834C17.7083 11.7382 17.4285 11.4584 17.0833 11.4584H12.5H11.4583M1 4L15.7973 18.7973M19.75 22.75L15.7973 18.7973M8 11.4583H6H3.75C3.40482 11.4583 3.125 11.7381 3.125 12.0833V15.625C3.125 19.0768 5.92322 21.875 9.375 21.875H11.4583C12.3056 21.9167 14.2 21.7 15 20.5C15.1982 20.1982 15.6352 19.4352 15.7973 18.7973" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="outline">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { CoffeeCupStrike };